import axios from 'axios';
import { API_CONFIG } from '../config/api.config';

export default file => new Promise((resolve, reject) => {
	const body = new FormData();
	body.append('file', file);

	const head = { headers: { token: localStorage.getItem('token') } };

	axios.post(`${API_CONFIG.ROUTE}${API_CONFIG.IMAGE}`, body, head)
		.then(res => resolve(res))
		.catch(err => reject(err));
});



// WEBPACK FOOTER //
// ./src/helpers/uploadImage.js